import React from 'react'
import { Route } from 'react-router-dom'
import { RecordRoute } from '../../../../shared/page/record-route'
import { Delete } from '../../../../shared/page/page-delete'
import { Purge } from '../../../../shared/page/page-purge'
import { AppStoreAdd } from './content/app-store/app-store-add'
import { AppStoreEdit } from './content/app-store/app-store-edit'
import { AppStoreList } from './content/app-store/app-store-list'
import { AppStoreRecycle } from './content/app-store/app-store-recycle'
import { AppVersionAdd } from './content/app-version/app-version-add'
import { AppVersionEdit } from './content/app-version/app-version-edit'
import { AppVersionList } from './content/app-version/app-version-list'
import { AppVersionRecycle } from './content/app-version/app-version-recycle'
import { AppAdd } from './content/app/app-add'
import { AppEdit } from './content/app/app-edit'
import { AppList } from './content/app/app-list'
import { AppRecycle } from './content/app/app-recycle'
import { useApiFormApp, useApiFormAppStore, useApiFormAppVersion, useApiFormAppBuildVersion } from '../../../../api-new/state/config'
import { AppBuildVersionlist } from './content/app-build-version/app-build-version-list'
import { AppBuildVersionEdit } from './content/app-build-version/app-build-version-edit'
import { AppBuildVersionRecycle } from './content/app-build-version/app-build-version-recycle'

export const LayoutApp = () => {
  return (
    <React.Fragment>
      {/* APP */}
      <Route path="/admin/app" component={AppList} />
      <Route path="/admin/app/add" component={AppAdd} />
      <RecordRoute path="/admin/app/edit/:appID" component={AppEdit} />
      <RecordRoute path="/admin/app/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormApp} titleParam="name" successPath="/admin/app" />
      </RecordRoute>
      <Route path="/admin/app/recycle" component={AppRecycle} />
      <RecordRoute path="/admin/app/recycle/purge/:purgeID">
        <Purge useApiForm={useApiFormApp} titleParam="name" successPath="/admin/app/recycle" />
      </RecordRoute>

      {/* APP STORE */}
      <Route path="/admin/app/edit/:appID/store" component={AppStoreList} />
      <Route path="/admin/app/edit/:appID/store/add" component={AppStoreAdd} />
      <RecordRoute path="/admin/app/edit/:appID/store/edit/:appStoreID" component={AppStoreEdit} />
      <RecordRoute path="/admin/app/edit/:appID/store/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormAppStore} titleParam="name" successPath="/admin/app/edit/:appID/store" />
      </RecordRoute>
      <Route path="/admin/app/edit/:appID/store/recycle" component={AppStoreRecycle} />
      <RecordRoute path="/admin/app/edit/:appID/store/recycle/purge/:purgeID">
        <Purge useApiForm={useApiFormAppStore} titleParam="name" successPath="/admin/app/edit/:appID/store/recycle" />
      </RecordRoute>

      {/* APP VERSION */}
      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version" component={AppVersionList} />
      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version/add" component={AppVersionAdd} />
      <RecordRoute path="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:appVersionID" component={AppVersionEdit} />

      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:appVersionID/version" component={AppBuildVersionlist} />
      <RecordRoute path="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:appVersionID/version/edit/:appBuildVersionID" component={AppBuildVersionEdit} />

      <Route
        path="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:appVersionID/version/recycle"
        component={AppBuildVersionRecycle}
      />
      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:appVersionID/version/recycle/purge/:purgeID">
        <Purge
          useApiForm={useApiFormAppBuildVersion}
          titleParam="filename"
          successPath="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:appVersionID/version/recycle"
        />
      </Route>

      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormAppVersion} titleParam="name" successPath="/admin/app/edit/:appID/store/edit/:appStoreID/version" />
      </Route>
      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version/recycle" component={AppVersionRecycle} />
      <Route path="/admin/app/edit/:appID/store/edit/:appStoreID/version/recycle/purge/:purgeID">
        <Purge useApiForm={useApiFormAppVersion} titleParam="name" successPath="/admin/app/edit/:appID/store/edit/:appStoreID/version/recycle" />
      </Route>
    </React.Fragment>
  )
}
